import { Attachment, ComposeMessageEditorErrorType } from "../../reducer.types";

/**
 * Returns an error if the user tried to send while
 * an attachment is still uploading
 */
export const validateAttachmentLoading = ({
    attachments,
}: {
    attachments: Attachment[];
}): Pick<ComposeMessageEditorErrorType, "attachmentLoading"> => {
    return attachments.some((a) => a.status === "loading")
        ? { attachmentLoading: "ATTACHMENT_STILL_LOADING" }
        : {};
};
